module.exports = __webpack_public_path__ + "img/sc.9db3c6a.webp";